module.exports = __webpack_public_path__ + "static/media/logo.d6715342.svg";